import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import packageJson from "../../package.json";
import { config } from "../config";
const VersionInfo = () => {
  const commitHash = config.REACT_APP_COMMIT_HASH;
  const buildDate = config.REACT_APP_BUILD_DATE;

  const tooltipComponent = (
    <Stack spacing={1}>
      <Typography variant="caption">Version: {packageJson.version}</Typography>
      {commitHash && (
        <Typography variant="caption">
          Commit: {commitHash.slice(0, 7)}
        </Typography>
      )}
      {buildDate && (
        <Typography variant="caption">
          Built: {new Date(buildDate).toLocaleString()}
        </Typography>
      )}
    </Stack>
  );
  return (
    <Tooltip title={tooltipComponent}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        className="w-full cursor-pointer"
        justifyContent="center"
      >
        <InfoOutlined fontSize="small" />
        <Typography variant="caption">A propos</Typography>
      </Stack>
    </Tooltip>
  );
};

export default VersionInfo;
